import {
  WELDIQ_ANALYTICS_NOT_READY,
  WELDIQ_SOME_JOBS_NOT_READY,
  formatPartialJobErrorsForDisplay,
  isWeldIqAnalyticsEmpty,
  isWeldIqUnavailable,
} from '../utils/weldIqEmptyState';
import type { WeldAnalyticsBundle } from '../types/weld';

interface WeldIqBundleStatusBannersProps {
  bundle: WeldAnalyticsBundle | null;
  /** Production weld rows mean the project pipeline already has data. */
  hasProductionData?: boolean;
}

/**
 * Calm banners for WeldIQ pipeline gaps — never dumps raw S3 / API error text.
 */
export const WeldIqBundleStatusBanners = ({
  bundle,
  hasProductionData = false,
}: WeldIqBundleStatusBannersProps) => {
  const unavailable = isWeldIqUnavailable(bundle);
  const analyticsEmpty = isWeldIqAnalyticsEmpty(bundle);
  const partialSummary = formatPartialJobErrorsForDisplay(bundle?.partialErrors);
  const showNotReady = (unavailable || analyticsEmpty) && !hasProductionData;
  const showPartialOnly =
    Boolean(partialSummary) && !unavailable && !analyticsEmpty && (bundle?.partialErrors?.length ?? 0) > 0;

  if (!showNotReady && !showPartialOnly) return null;

  return (
    <div className="space-y-3">
      {showNotReady && (
        <div
          role="status"
          className="rounded-lg border border-dashed border-[#E2E5EA] bg-[rgba(0,39,63,0.03)] px-3 py-2 text-sm text-heritage-grey"
        >
          <p>{WELDIQ_ANALYTICS_NOT_READY}</p>
        </div>
      )}
      {showPartialOnly && (
        <div
          role="status"
          className="rounded-lg border border-dashed border-[#E2E5EA] bg-[rgba(0,39,63,0.03)] px-3 py-2 text-sm text-heritage-grey"
        >
          <p>{partialSummary || WELDIQ_SOME_JOBS_NOT_READY}</p>
        </div>
      )}
    </div>
  );
};
